import axios from './_nestAxios'

export const getSubFamilia = _id => axios.get(`/subfamilias/${_id}`)

export const getSubFamilias_Select = idFamilia =>
  axios.get('/subfamilias', {
    params: {
      tipoConsulta: 'select',
      idFamilia
    }
  })

export const insertarSubFamilia = data => axios.post('/subfamilias/nuevo', data)

export const actualizarSubFamilia = (_id, data) => axios.put(`/subfamilias/${_id}`, data)

export const eliminarSubFamilia = _id => axios.delete(`/subfamilias/${_id}`)